import React from 'react';
import './TestimonialCard.css';

const TestimonialCard = ({ name, feedback, className }) => {
    return (
        <div className={`testimonial-card ${className}`}>
            <div className="avatar">{name.charAt(0)}</div>
            <div>
                <h3>{name}</h3>
                <p>{feedback}</p>
            </div>
        </div>
    );
}

export default TestimonialCard;
